export default "__VITE_ASSET__BcPBFVVT__"